import * as React from 'react';
import { IRestockingCalculatorProps } from './RestockingCalculator.properties';
import { withStyles } from '@material-ui/core';
import styles from './RestockingCalculator.styles';
import CalculatorField from '../CalculatorField';
import { CalculatorDialogForm } from './RestockingChargeCalculator.form';
import RestockingCalculatorSummaryTableSchema from './RestockingChargeCalculator.summaryable.schema';
import { useCalculateRestockingCharge } from 'api/creditNotes/creditNotes';

const RestockingCalculator = (props: IRestockingCalculatorProps) => {
    const { onChange, creditNoteId, lineNumber, creditAmount, onValueChanged, ...rest } = props;

    const [initialValues, setInitialValues] = React.useState(null);
    const [valuesSchema, setValuesSchema] = React.useState(null);
    const [fieldValue, setFieldValue] = React.useState<any>(props.value || 0);

    React.useEffect(
        () => {
            setFieldValue(props.value);
        },
        [props.value]);

    const calculateRestockingChargeMutation = useCalculateRestockingCharge();

    const calculateRestockingCharge = (values: any, initialize: boolean = false): void => {
        calculateRestockingChargeMutation.mutateAsync({
            WorkCreditNoteId: creditNoteId,
            LineNumber: lineNumber || undefined,
            Initialise: initialize,
            CreditAmount: values?.CreditAmount || creditAmount || 0,
            RestockingPercentage: values?.RestockingPercentage || 0,
        }).then((response) => {
            if (response?.RestockingChargeCalculator?.inlineObject) {
                setInitialValues(response?.RestockingChargeCalculator?.inlineObject);
                setValuesSchema(response?.RestockingChargeCalculator?.schema);
            }
        });
    };

    const onChangeHandler = (value: any): void => {
        if (value?.fieldValue) {
            setFieldValue(value?.fieldValue);
            if (onChange) {
                onChange(value?.fieldValue);
            }
            if (onValueChanged) {
                onValueChanged(value?.fieldValue);
            }
        } else if (value !== undefined) {
            setFieldValue(value?.TotalRestockingCharge);
            if (onChange) {
                onChange(value?.TotalRestockingCharge);
            }
            if (onValueChanged) {
                onValueChanged(value?.TotalRestockingCharge);
            }
        }
    };

    return (
        <CalculatorField
            {...rest}
            value={fieldValue}
            dialogTitle='Restocking Charge Calculator'
            formSchema={CalculatorDialogForm}
            initialValues={initialValues}
            valuesSchema={valuesSchema}
            summaryTableData={initialValues}
            summaryTableSchema={RestockingCalculatorSummaryTableSchema}
            onCalculate={(values) => {
                calculateRestockingCharge(values);
            }}
            onChange={onChangeHandler}
            onCalculatorDialogOpen={() => { calculateRestockingCharge(null, true); }}
            size='medium'
            alignment='right'
            decimalSeparator={true}
            type='number'
        />
    );
};

export default withStyles(styles)(RestockingCalculator);
